package com.exura.features.plandefinition.domain.model.series

import kotlinx.serialization.Serializable

@Serializable
data class HourOfDay (
    val hour: Int = 0,
    val minute: Int = 0
)

enum class PartOfDay(val label: String) {
    MORNING("morning"),
    NOON("noon"),
    AFTERNOON("afternoon"),
    EVENING ("evening"),
    NIGHT("night"),
    TODAY("today"),
}
